/* istanbul ignore file */
export default ({
  palette: { common, grey, text },
  spacing: { unit },
  typography: { fontSize, fontWeightHeavy }
}) => ({
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    '&.disabledRadioBtnContainer': {
      cursor: 'not-allowed',
      opacity: 0.9
    }
  },
  title: {
    fontSize: unit * 1.5,
    fontWeight: fontWeightHeavy,
    textTransform: 'uppercase',
    color: grey.G600,
    margin: [0, 10, 0, 0]
  },
  titleOnTop: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& $title': {
      margin: [0, 0, 10, 0]
    }
  },
  radioContainer: {
    display: 'flex',
    '&.disabledRadioBtn': {
      pointerEvents: 'none',
      '& .radioBtn': {
        backgroundColor: `${grey.G300} !important`
      }
    }
  },
  radioVertical: {
    flexDirection: 'column',

    '& $radioWrapper': {
      margin: [unit / 2, 0]
    }
  },
  radioWrapper: {
    '& > label': {
      color: text.dark,
      fontSize,
      fontWeight: 'normal',
      margin: `0 ${unit * 3}px 0 ${unit}px`
    },
    '&.styledRadioBtn': {
      display: 'inline-block',
      fontWeight: 100,
      position: 'relative',
      '& > label': {
        cursor: 'pointer',
        marginLeft: '0 !important',
        paddingLeft: unit * 3,
        position: 'relative'
      },
      '& > input': {
        opacity: 0,
        position: 'absolute',
        '&:checked + .radioBtn': {
          '&:after': {
            background: '#4c4c4c',
            borderRadius: '50%',
            content: '""',
            height: 10,
            left: 2,
            position: 'absolute',
            top: 2,
            width: 10
          }
        }
      },
      '& > .radioBtn': {
        backgroundColor: common.white,
        border: `1px solid ${grey.G600}`,
        borderRadius: '50%',
        position: 'absolute',
        top: 'calc(50% - 8px)',
        left: 0,
        width: 16,
        height: 16
      }
    }
  }
});
